<div class="dialog-header">
  <h2 mat-dialog-title>{{ 'addVolumeDialog.title' | translate }}</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="app-info">
    <p><strong>{{ 'addVolumeDialog.company' | translate }}:</strong> {{ data.assignment.application.companyName }}</p>
    <p><strong>{{ 'addVolumeDialog.meatType' | translate }}:</strong> {{ getMeatTypeName(data.assignment.application.meatType) }}</p>
    <p><strong>{{ 'addVolumeDialog.distributedVolume' | translate }}:</strong> {{ data.assignment.allocatedVolume / 1000 }} {{ 'addVolumeDialog.tons' | translate }}</p>
    <p><strong>{{ 'addVolumeDialog.remainder' | translate }}:</strong> {{ data.assignment.remainderVolume / 1000 }} {{ 'addVolumeDialog.tons' | translate }}</p>
  </div>

  <form class="form-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'addVolumeDialog.pin' | translate }}</mat-label>
      <input matInput [ngModel]="personIdnp" name="personIdnp"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'personIdnp')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['personIdnp']) {
      <div class="field-error">{{ fieldErrors()['personIdnp'] }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'addVolumeDialog.organizationInn' | translate }}</mat-label>
      <input matInput [ngModel]="organizationInn" name="organizationInn"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'organizationInn')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['organizationInn']) {
      <div class="field-error">{{ fieldErrors()['organizationInn'] }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'addVolumeDialog.deliveredVolume' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="deliveredVolume" name="deliveredVolume" min="0.001" step="0.001">
      <mat-hint>{{ 'addVolumeDialog.volumeHint' | translate }}</mat-hint>
    </mat-form-field>
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">{{ 'addVolumeDialog.cancel' | translate }}</button>
  <button mat-raised-button color="primary"
          (click)="submit()"
          [disabled]="!isFormValid() || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      {{ 'addVolumeDialog.signAndSave' | translate }}
    }
  </button>
</mat-dialog-actions>
